import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { UserAuthenticationService } from "@app/authentication/shared/user-authentication.service";
import { UserService } from "@app/user/user-profile/shared/user.service";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { UserCurrentInfoModel } from "@app/user/user-profile/shared/user-current-info-model";
import { ObservabilityService } from "@app/shared/services/observability.service";

@Component({
    selector: "navbar-user",
    templateUrl: "./navbar-user.component.html",
    styleUrls: ["../navbar-plugin-base.scss", "./navbar-user.component.scss"],
})
export class NavbarUserComponent {
    private _authenticationDs = inject(UserAuthenticationService);
    _tabservice = inject(TabService);
    _pages = inject(Pages);
    private observabilityService = inject(ObservabilityService);
    private userDS = inject(UserService);

    @Input() lightRopeEnabled: boolean;
    @Output() lightRopeEnabledChange = new EventEmitter<boolean>();
    @Input() isHolidaySeason: boolean;

    userInfo: UserCurrentInfoModel;
    hideNameInToolbar = false;

    constructor() {
        this.userDS.getUserInfoBase().subscribe((ui) => {
            this.userInfo = ui;
            setTimeout(() => {
                this.hideNameInToolbar = true;
            }, 5000);
        });
    }

    openProfile() {
        this._tabservice.generateTab(this._pages.Profile);
    }

    toggleLightRope() {
        this.lightRopeEnabled = !this.lightRopeEnabled;
        this.lightRopeEnabledChange.emit(this.lightRopeEnabled);
    }

    signOut() {
        this._authenticationDs.logout().subscribe(() => {
            this.observabilityService.logoutUser();
            window.location.href = window.location.origin;
        });
    }
}
